<template>
  <ConfigProvider :locale="localeMap[locale].ant" :autoInsertSpaceInButton="false">
    <div class="content-wrap">
      <a-config-provider
          :theme="{
        token: {
          colorPrimary: '#e60000', // 将主题色设置为红色
          colorLink: '#e60000',    // 链接颜色也设为红色
          borderRadius: 4,         // 可选：设置圆角大小
        }
      }">
        <router-view/>
      </a-config-provider>
    </div>
  </ConfigProvider>
</template>
<script lang="ts" setup>
import {computed, onErrorCaptured, provide, reactive, watch} from "vue";
import {ConfigProvider} from "ant-design-vue";
import {hasPower, lang} from "@/utils";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import enUS from "ant-design-vue/es/locale/en_US";
import ptBR from "ant-design-vue/es/locale/pt_BR";
import {Locale} from "ant-design-vue/lib/locale-provider";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn.js";
import "dayjs/locale/pt-br.js";
import "dayjs/locale/en.js";
import {useRouter} from "vue-router";

import {usePhoneModel} from "@/hooks/usePhoneModel"
import FingerprintJS from "@fingerprintjs/fingerprintjs";

const phoneModel = usePhoneModel()

localStorage.setItem('sys_deviceModel', phoneModel.getPhoneSystemType()?.name || 'chrome')
FingerprintJS.load().then(fingerprint => {
  // 获取浏览器指纹
  fingerprint.get().then(result => {
    // result.visitorId 包含生成的唯一指纹
    localStorage.setItem('sys_deviceId', result.visitorId)
  });
});

const router = useRouter();
type Lang = keyof typeof any
const sysSetting = localStorage.getItem("lang") || "pt";

const localeMap = reactive<Record<Lang, { ant: Locale; dayjs: string }>>({
  zh: {
    ant: zhCN,
    dayjs: "zh-ch"
  },
  pt: {
    ant: ptBR,
    dayjs: "pt-br"
  },
  en: {
    ant: enUS,
    dayjs: "en"
  }
});
const locale = computed(() => sysSetting);
dayjs.locale(localeMap[locale.value].dayjs);

watch(
    () => locale.value,
    (c) => {
      console.log(c);
      dayjs.locale(localeMap[c].dayjs);
    }
);

// onMounted(() => {
// })

provide('hasPower', (key: string) => {
  return hasPower && hasPower(key)
})
provide('lang', (key: string) => {
  return (lang(key)) || key
})
provide('searchFormLayout', 'vertical')
provide('searchItemWidth', '300px')
provide('stylization', 'jms')

onErrorCaptured((err) => {
  console.error('组件更新错误:', err);
  return true; // 阻止错误继续向上传播
});
</script>

